var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, SimpleChanges, OnChanges, ElementRef } from '@angular/core';
import { AssessmentComponent } from '../assessment/assessment.component';
import { AlertService } from 'app/shared/services/alert.service';
import { QuestionAnswerPopulator } from 'app/shared/services/question-answer-populator.service';
import { QuestionSet } from 'app/shared/models/question-set';
import * as jQuery from "jquery";
import { QuestionType } from 'app/shared/models/question-type';
var AssessmentSingleQuestionDisplayComponent = /** @class */ (function (_super) {
    __extends(AssessmentSingleQuestionDisplayComponent, _super);
    // TODO: stephen single question display doesn't currently handle branching and that's a harder problem to solve...
    function AssessmentSingleQuestionDisplayComponent(alertService, questionPopulator, element) {
        var _this = _super.call(this, alertService, questionPopulator) || this;
        _this.element = element;
        _this.showInstructions();
        return _this;
    }
    AssessmentSingleQuestionDisplayComponent.prototype.ngOnInit = function () {
    };
    AssessmentSingleQuestionDisplayComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
    };
    AssessmentSingleQuestionDisplayComponent.prototype.handleListAnswer = function (questions) {
        console.log("Set was answered.  Questions answered: ", questions);
        var skipAutoSubmit = questions.some(function (q) {
            return q.type == QuestionType.Textbox || q.type == QuestionType.Checklist;
        });
        if (!skipAutoSubmit) {
            // TODO: stephen there is a bug if the question is a Textbox it marks the textbox as answered with one character and tries to move
            // to the next set on every single character typed...
            this.nextSet();
        }
    };
    AssessmentSingleQuestionDisplayComponent.prototype.getQuestionSetsForDisplay = function (assessment) {
        if (this._cachedDisplaySets
            && this._currentAssessment
            && this._currentAssessment == assessment) {
            return this._cachedDisplaySets;
        }
        else {
            this._currentAssessment = assessment;
            this._cachedDisplaySets = [];
        }
        // TODO: stephen this doesn't handle branching...
        var displaySetList = [];
        assessment.getQuestionSetsForDisplay();
        this.assessment.question_sets.forEach(function (qs) {
            var firstQuestion = true;
            qs.questions.forEach(function (q) {
                var displaySet = Object.assign(new QuestionSet(), qs);
                // only show the instructions on the first question of the set.
                displaySet.instructions = firstQuestion ? displaySet.instructions : "";
                firstQuestion = false;
                displaySet.questions = [q];
                displaySetList.push(displaySet);
            });
        });
        this._cachedDisplaySets = displaySetList;
        return displaySetList;
    };
    AssessmentSingleQuestionDisplayComponent.prototype.getNextQuestionSetToDisplay = function (assessment, currentQuestionSet) {
        var index = this._cachedDisplaySets.indexOf(currentQuestionSet);
        if (index >= 0 && index < this._cachedDisplaySets.length - 1) {
            return this._cachedDisplaySets[index + 1];
        }
        return null;
    };
    AssessmentSingleQuestionDisplayComponent.prototype.getPreviousQuestionSetToDisplay = function (assessment, currentQuestionSet) {
        var index = this._cachedDisplaySets.indexOf(currentQuestionSet);
        if (index > 0) {
            return this._cachedDisplaySets[index - 1];
        }
        return null;
    };
    AssessmentSingleQuestionDisplayComponent.prototype.nextSet = function () {
        var _this = this;
        if (this.hasNextSet) {
            if (this.hasUnansweredQuestions()) {
                // display an alert
                this.alertService.error("Please answer all of the questions before proceeding");
                return;
            }
            jQuery(this.element.nativeElement.querySelector("#question-list")).fadeOut('fast', function () {
                _super.prototype.nextSet.call(_this);
                jQuery(_this).fadeIn();
            }).fadeIn();
        }
    };
    AssessmentSingleQuestionDisplayComponent.prototype.previousSet = function () {
        var _this = this;
        if (this.hasPreviousSet) {
            jQuery(this.element.nativeElement.querySelector("#question-list")).fadeOut('fast', function () {
                _super.prototype.previousSet.call(_this);
                if (!_this.hasPreviousSet) {
                    _this.showInstructions(); // show the instructions if we've gone back to the beginning.
                }
                jQuery(_this).fadeIn();
            }).fadeIn();
        }
        else {
        }
    };
    return AssessmentSingleQuestionDisplayComponent;
}(AssessmentComponent));
export { AssessmentSingleQuestionDisplayComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/assessment-single-question-display/assessment-single-question-display.component.ts.pre-build-optimizer.js